const ROOT_PICKER_INJECTION_KEY = Symbol();

export { ROOT_PICKER_INJECTION_KEY };
//# sourceMappingURL=constants.mjs.map
